// Needed polyfills for React 16 for older browsers.
// See https://reactjs.org/blog/2017/09/26/react-v16.0.html#javascript-environment-requirements
import "core-js/modules/es.map";
import "core-js/modules/es.set";

// Needed polyfill to support an iterable ObjSearch in older browsers.
// See https://www.scrivito.com/objsearch-aaa67c3157464d01
import "core-js/modules/es.symbol";
